import { Edit, SaveOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';

interface LearningBudgetSetupActionsProps {
  onSetTeamLB?: () => void;
  onSetMembersLB?: () => void;
  onSaveSetup?: () => void;
  disabled?: boolean;
}

export const LearningBudgetSetupActions = ({
  onSetTeamLB,
  onSetMembersLB,
  onSaveSetup,
}: LearningBudgetSetupActionsProps) => {
  const {
    formState: { isDirty, isSubmitting, disabled },
  } = useFormContext();

  return (
    <Stack
      direction="row"
      alignItems="center"
      className="border-b gap-2 py-2 pl-4 pr-2 border-divider-light"
    >
      <Button
        variant="text"
        startIcon={<Edit />}
        onClick={onSetTeamLB}
        disabled={disabled || isSubmitting}
      >
        Set LB for a Team
      </Button>
      <Button
        variant="text"
        startIcon={<Edit />}
        onClick={onSetMembersLB}
        disabled={disabled || isSubmitting}
      >
        Set LB for Members
      </Button>
      <Button
        variant="text"
        className="ml-auto bg-white"
        startIcon={<SaveOutlined />}
        onClick={onSaveSetup}
        loading={isSubmitting}
        disabled={!isDirty || disabled}
      >
        Save Cycle
      </Button>
    </Stack>
  );
};
